module.exports = __webpack_public_path__ + "img/frame (66).89ee4021.jpg";